$(function(){
  $('.flash-message').each(function(index, element){
    setTimeout(function(){
      $(element).slideUp(200);
    }, 2000);
  });
});



// WEBPACK FOOTER //
// ./resources/assets/js/flash-messages-customization.js